// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select_Select__2izju","AriaDescription":"Select_AriaDescription__32LsK","FullWidth":"Select_FullWidth__1ckOY"};